import { render, staticRenderFns } from "./ImpersonateView.vue?vue&type=template&id=cf9b89fe&"
import script from "./ImpersonateView.vue?vue&type=script&lang=js&"
export * from "./ImpersonateView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports